export const UPDATE_PROGRESS_STEP = "UPDATE_PROGRESS_STEP";
export const UPDATE_INBOUND_SELECTION = "UPDATE_INBOUND_SELECTION";
export const UPDATE_OUTBOUND_SELECTION = "UPDATE_OUTBOUND_SELECTION";
export const UPDATE_TRANSACTIONAL_SELECTION = "UPDATE_TRANSACTIONAL_SELECTION";
export const UPDATE_CART_START = "UPDATE_CART_START";
export const UPDATE_CART_SUCCESS = "UPDATE_CART_SUCCESS";
export const UPDATE_CART_ERROR = "UPDATE_CART_ERROR";
export const FETCH_CART_START = "FETCH_CART_START";
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";
export const FETCH_CART_ERROR = "FETCH_CART_ERROR";
export const APPLY_COUPON_START = "APPLY_COUPON_START";
export const APPLY_COUPON_SUCCESS = "APPLY_COUPON_SUCCESS";
export const APPLY_COUPON_ERROR = "APPLY_COUPON_ERROR";

export const defaultAppState = {
    step: 0, //progress bar step: 0: price selection, 1: account creation ,2: billing, 3: email verification
    inbound: {
        planHandle: null,
        allocation: null,
        coupons: [],
    },
    outbound: {
        planHandle: null,
        allocation: null,
        coupons: [],
    },
    transactional: {
        planHandle: null,
        coupons: [],
    },
    loading: 0,
    cart: null,
    errors: [],
};

export const AppContextReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_PROGRESS_STEP:
            return {
                ...state,
                step: payload,
            };
        case UPDATE_INBOUND_SELECTION:
            return {
                ...state,
                inbound: {
                    planHandle: payload.planHandle,
                    allocation: payload.allocation,
                    coupons: payload.coupons,
                },
            };
        case UPDATE_OUTBOUND_SELECTION:
            return {
                ...state,
                outbound: {
                    planHandle: payload.planHandle,
                    allocation:
                        payload.allocation !== undefined
                            ? payload.allocation
                            : state.outbound.allocation,
                    coupons: payload.coupons,
                },
            };
        case UPDATE_TRANSACTIONAL_SELECTION:
            return {
                ...state,
                transactional: {
                    planHandle: payload.planHandle,
                    coupons: payload.coupons,
                },
            };
        case UPDATE_CART_START:
            return {
                ...state,
                loading: state.loading + 1,
            };
        case UPDATE_CART_SUCCESS:
            return {
                ...state,
                cart: payload,
                loading: state.loading - 1,
            };
        case UPDATE_CART_ERROR:
            return {
                ...state,
                loading: state.loading - 1,
                errors: state.errors.concat([payload.error]),
            };
        case FETCH_CART_START:
            return {
                ...state,
                loading: state.loading + 1,
            };
        case FETCH_CART_SUCCESS:
            return {
                ...state,
                cart: payload,
                loading: state.loading - 1,
            };
        case FETCH_CART_ERROR:
            return {
                ...state,
                loading: state.loading - 1,
                errors: state.errors.concat([payload.error]),
            };
        case APPLY_COUPON_START:
            return {
                ...state,
                loading: state.loading + 1,
            };
        case APPLY_COUPON_SUCCESS:
            return {
                ...state,
                cart: payload,
                loading: state.loading - 1,
            };
        case APPLY_COUPON_ERROR:
            return {
                ...state,
                loading: state.loading - 1,
                errors: state.errors.concat([payload.error]),
            };
        default:
            throw new Error();
    }
};
